import { withFieldGroup } from '@massilia/features'
import { Label, RadioGroup, RadioGroupItem } from '@massilia/ui'

import type { CheckoutFormValues, FloaPayTypeFormValue } from '../checkout-form.schema'

interface InstallmentsSubFormProps {
  /** Prestataire courant du paiement en plusieurs fois (flag runtime serveur) */
  provider: 'FLOA' | 'SSP'
}

export const InstallmentsSubForm = withFieldGroup({
  defaultValues: {} as Pick<
    CheckoutFormValues,
    'billingCity' | 'billingCountryCode' | 'billingStreet' | 'billingZipCode' | 'floaPayType'
  >,
  props: {} as InstallmentsSubFormProps,
  render: function InstallmentsSubFormFields({ group, provider }) {
    const isFloa = provider === 'FLOA'

    return (
      <div className="flex flex-col gap-4">
        {isFloa ? (
          <p className="text-gray-light-700 text-sm">
            Vous serez redirigé vers la plateforme sécurisée FLOA Bank pour finaliser votre
            paiement.
          </p>
        ) : (
          <p className="text-gray-light-700 text-sm">
            Vous serez redirigé vers notre plateforme de paiement sécurisée. Le choix entre 3 ou 4
            fois se fait sur la page de paiement.
          </p>
        )}

        {/* 3x / 4x selector — choix côté Massilia uniquement pour FLOA */}
        {isFloa && (
          <group.AppField name="floaPayType">
            {(field) => (
              <RadioGroup
                onValueChange={(value) => field.handleChange(value as FloaPayTypeFormValue)}
                value={field.state.value as FloaPayTypeFormValue}
              >
                <div className="flex items-center gap-2">
                  <RadioGroupItem value="3XG" />
                  <Label className="cursor-pointer font-normal" htmlFor="3XG">
                    3 fois
                  </Label>
                  <RadioGroupItem value="4XG" />
                  <Label className="font-normal text-gray-600" htmlFor="4XG">
                    4 fois
                  </Label>
                </div>
              </RadioGroup>
            )}
          </group.AppField>
        )}

        {/* Billing address */}
        <div className="flex flex-col gap-3">
          <Label className="text-sm font-medium">Adresse de facturation</Label>

          <group.AppField name="billingStreet">
            {(field) => <field.TextField placeholder="N° et rue (ex : 25 Rue de Paris)" />}
          </group.AppField>

          <div className="flex gap-3">
            <group.AppField name="billingZipCode">
              {(field) => <field.TextField placeholder="Code postal" />}
            </group.AppField>

            <group.AppField name="billingCity">
              {(field) => <field.TextField placeholder="Ville" />}
            </group.AppField>
          </div>

          <group.AppField name="billingCountryCode">
            {(field) => <field.CountryAutocompleteField placeholder="Pays" />}
          </group.AppField>
        </div>
      </div>
    )
  },
})
